import * as go from 'gojs';
import * as _ from 'lodash/fp';
import { iteratorToArray } from '../iterator-to-array';
import { BACK_LAYER_NAME, FRONT_LAYER_NAME } from './config';

export const getFrontLayer = (diagram: go.Diagram) => diagram.findLayer(FRONT_LAYER_NAME);

export const getBackLayer = (diagram: go.Diagram) => diagram.findLayer(BACK_LAYER_NAME);

export const setOrderingProps = (
  part: go.Part,
  zOrder: number,
  layerName: string,
  zOrderProp?: string,
  layerProp?: string,
) => {
  if (layerProp) {
    if (part.diagram) {
      part.diagram.model.set(part.data, layerProp, layerName);
    }
  } else {
    part.layerName = layerName;
  }

  if (zOrderProp) {
    if (part.diagram) {
      part.diagram.model.set(part.data, zOrderProp, zOrder);
    }
  } else {
    part.zOrder = zOrder;
  }
};

export const findExtremeZOrders = (layer: go.Layer) =>
  _.flowRight(
    ([highestPart, lowestPart]: [go.Part, go.Part]) => ({
      highestZOrder: highestPart ? highestPart.zOrder : 0,
      lowestZOrder: lowestPart ? lowestPart.zOrder : 0,
    }),
    _.over([_.maxBy((part: go.Part) => part.zOrder), _.minBy((part: go.Part) => part.zOrder)]),
    _.filter((part: go.Part) => !isNaN(part.zOrder)),
    iteratorToArray,
  )(layer.parts);
